import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

// Pages
import { AuthProvider } from "./pages/AuthContext";
import PrivateRoute from "./pages/PrivateRoute";
import LoginPage from "./pages/Login";
import Register from "./pages/Register";
import RecoveryPage from "./pages/RecoveryPage";
import Arms from "./pages/arms";
import ArmsListForm from "./pages/armslist";
import Passcert from "./pages/Passcert";
import SpecailDSR from "./pages/SpecailDSR";
import GeneralDSR from "./pages/GeneralDSR";
import Localcertificate from "./pages/Localcertificate";
import Localdomicile from "./pages/Localdomicile";
import ComplaintForm from "./pages/ComplaintForm";
import Birthcert from "./pages/Birthcert";
import Marriagecert from "./pages/Marriagecert";
import Deathcert from "./pages/Deathcert";
import FIR from "./pages/FIR";
import FIRList from "./pages/FIRlist";
import Editform from "./pages/EditFir";

// Dashboards
import Dashboard from "./pages/Admin Dashboard";
import ArmsDashboard from "./pages/ArmsDashboard";
import DSRDashboard from "./pages/DSRDashboard";
import FIRDashboard from "./pages/FIRDashboard";
import PassportDashboard from "./pages/PassportDashboard";
import LocalDashboard from "./pages/LocalDashboard";
import LocalDomicileDashboard from "./pages/LocalDomicileDashboard";
import CertificateDashboard from "./pages/CertificateDashboard";

import EditBirthCert from "./pages/Editbirthcert";
import EditArmsf from "./pages/Editarms";
import DashboardLayout from "./pages/DashboardLayout";
import LocalCertificateDashboard from "./pages/LocalDashboard";
import ClientComplaintDashboard from "./pages/ClientComplaintDashboard";
import ReadersDashboard from "./pages/ReadersDashboard";
import EditGDSR from "./pages/EditGDSR";
import GDSRList from "./pages/GDSRList";
import BirthCertificateList from "./pages/Birthcertlist";
import DeathCertificateList from "./pages/Deathcertlist";
import EditDeathCert from "./pages/Editdeathcert";
import MarriageCertificateList from "./pages/Marriagecertlist";
import EditMarriageCert from "./pages/Editmarriagecert";
import LocalCertificateList from "./pages/localcertlist";
import EditLocalCert from "./pages/EditLocalCertificate";
import Localdomlist from "./pages/localdomlist";
import EditLocaldom from "./pages/EditLocaldom";
import PassportList from "./pages/Passcertlist";
import EditPassport from "./pages/Editpasscert";
import SDSRList from "./pages/SDSRList";
import EditSDSRForm from "./pages/EditSDSR";
import Form_f from "./pages/FIR";
import SearchForm from "./pages/searchform";
import SplashScreen from "./pages/SplashScreen";
import AnnouncementForm from "./pages/AnnouncementForm";
import ACSDashboard from "./pages/ACSDashboard";
import MutationForm from "./pages/Mutation";
import MutationLedger from "./pages/MutationLedger";
import FardForm from "./pages/Fard";
import FardList from "./pages/FardList";
import FardLedger from "./pages/FardLedger";
import PropDashboard from "./pages/PropertyDashboard";
import TehsildarDashboard from "./pages/TehsildarDashboard";
import MutationList from "./pages/MutationList1";
import Summary from "./pages/Summary";
import ComplaintList from "./pages/ComplaintsTable";
import EditArmsfstatus from "./pages/Editarmsstatus";
import ArmsLicenseList from "./pages/armslicenselist";
import BCMarriage from "./pages/BarcodeScannerMarriage";
import BarcodeScanner from "./pages/Scanner";
import HistoryAuditForm from "./pages/HistoryAudit";
import AuditHistory from "./pages/AuditHistory";
import OnlineApp from "./pages/onlineapplication";

// New Component
function WelcomeApp() {
  return (
    <div>
      <h1>Welcome to E-Chaman</h1>
      <button id="install-button" style={{ display: "block" }}>
        <img
          src="/install-icon.png"
          alt="Install Icon"
          style={{ width: "24px", height: "24px", marginRight: "8px" }}
        />
        Install App
      </button>

    </div>
  );
}

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          {/* <Route path="*" element={<SplashScreen />} /> */}
          <Route path="*" element={<LoginPage />} />
          <Route path="/complaint" element={<ComplaintForm />} />
          <Route path="/Online-Form" element={<OnlineApp />} />
          <Route path="/splash" element={<SplashScreen />} />

          {/* <Route path="/verification" element={<BCMarriage />} /> */}
          {/* <Route path="/history-audit" element={<AuditHistory />} /> */}

          {/* New Welcome Component Route */}
          <Route path="/welcome" element={<WelcomeApp />} />

          {/* Protected Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/arms-dashboard"
            element={
              <PrivateRoute>
                <ArmsDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/arms-license"
            element={
              <PrivateRoute>
                <Arms />
              </PrivateRoute>
            }
          />

          {/* Announcement Form Okie */}

          <Route
            path="/announcement"
            element={
              <PrivateRoute>
                <AnnouncementForm />
              </PrivateRoute>
            }
          />

          <Route
            path="/complaints-cell"
            element={
              <PrivateRoute>
                <ClientComplaintDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/arms-list"
            element={
              <PrivateRoute>
                <ArmsListForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/arms-list"
            element={
              <PrivateRoute>
                <ArmsListForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/commissioner-qta-sdsr"
            element={
              <PrivateRoute>
                <ReadersDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-hub-sdsr"
            element={
              <PrivateRoute>
                <ACSDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/e-property"
            element={
              <PrivateRoute>
                <PropDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/tehsildar-dashboard"
            element={
              <PrivateRoute>
                <TehsildarDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-arms-license"
            element={
              <PrivateRoute>
                <EditArmsf />
              </PrivateRoute>
            }
          />
          <Route
            path="/dsr-dashboard"
            element={
              <PrivateRoute>
                <DSRDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/passport-dashboard"
            element={
              <PrivateRoute>
                <PassportDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/local-domicile-dashboard"
            element={
              <PrivateRoute>
                <LocalDomicileDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/local-certificate-dashboard"
            element={
              <PrivateRoute>
                <LocalCertificateDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/certificates-dashboard"
            element={
              <PrivateRoute>
                <CertificateDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/fir-dashboard"
            element={
              <PrivateRoute>
                <FIRDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/fir"
            element={
              <PrivateRoute>
                <Form_f />
              </PrivateRoute>
            }
          />
          <Route
            path="/fir-list"
            element={
              <PrivateRoute>
                <FIRList />
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-fir"
            element={
              <PrivateRoute>
                <Editform />
              </PrivateRoute>
            }
          />
          <Route
            path="/mutation-form"
            element={
              <PrivateRoute>
                <MutationForm />
              </PrivateRoute>
            }
          />

          <Route
            path="/fird-form"
            element={
              <PrivateRoute>
                <FardForm />
              </PrivateRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >

            {/* Nested Protected Routes */}
            <Route path="summary-report" element={<Summary/>} />
            <Route path="fard-list" element={<FardList/>} />
            <Route path="fard-ledger" element={<FardLedger />} />
            <Route path="mutation-list" element={<ArmsListForm />} />
            <Route path="mutation-ledger" element={<MutationLedger />} />
            <Route path="arms-list" element={<ArmsListForm />} />
            <Route path="edit-arms-license" element={<EditArmsf />} />
            <Route path="gdsr-list" element={<GDSRList />} />
            <Route path="edit-gdsr" element={<EditGDSR />} />
            <Route path="birth-certificate-list" element={<BirthCertificateList />} />
            <Route path="edit-birth-certificate" element={<EditBirthCert />} />
            <Route path="death-certificate-list" element={<DeathCertificateList />} />
            <Route path="edit-death-certificate" element={<EditDeathCert />} />
            <Route path="marriage-certificate-list" element={<MarriageCertificateList />} />
            <Route path="edit-marriage-certificate" element={<EditMarriageCert />} />
            <Route path="local-certificate-list" element={<LocalCertificateList />} />
            <Route path="edit-local-certificate" element={<EditLocalCert />} />
            <Route path="local-domicile-list" element={<Localdomlist />} />
            <Route path="edit-local-domicile" element={<EditLocaldom />} />
            <Route path="passport-list" element={<PassportList />} />
            <Route path="edit-passport" element={<EditPassport />} />
            <Route path="special-dsr-list" element={<SDSRList />} />
            <Route path="edit-special-dsr" element={<EditSDSRForm />} />
            <Route path="fir-list" element={<FIRList />} />
            <Route path="edit-fir" element={<Editform />} />
            <Route path="fir" element={<Form_f />} />
            <Route path="search-application" element={<SearchForm />} />
            <Route path="announcement" element={<AnnouncementForm />} />
            <Route path="edit-arms-license-status" element={<EditArmsfstatus />} />
            <Route path="arms-license-list" element={<ArmsLicenseList />} />
            <Route path="history-audit" element={<HistoryAuditForm />} />
            <Route path="*" element={<Navigate to="*" />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App; 
